export default __webpack_public_path__ + "static/media/filter.917a216f.svg";